<div *ngIf="!onsetStarted" class="container-fluid p-0" style="position: relative"
  [style.background-color]="clozeTestStyleModel.siteBackground">
  <div class="d-flex justify-content-center"
    [ngClass]="{'h-100': mobileMode, 'h-100': displayStatus === 'SHOW_DESKTOP_WARNING'}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode, 'p-0': mobileMode}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel.exerciseBackground"
      [ngStyle]="{'border': mobileMode ? '0px' : '1px solid ' + clozeTestStyleModel.frameColor, 'border-radius': mobileMode? '0px' : '0.25rem', 'width': mobileMode? '' : '720px'}">
      <!-- mobile exercise header -->
      <div *ngIf="mobileMode" class="onset-indicator">
        <img style="max-width: 100px;float: right;" [src]="cTestLogo">
      </div>
      <!-- body-->
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode }" [style.font-family]="clozeTestStyleModel.font"
        [style.font-size]="clozeTestStyleModel.fontSize">
        <img *ngIf="clozeTestStyleModel.displayLogo && !mobileMode" class="floating-logo" [src]="cTestLogo">
        <div style="cursor: pointer;">
          <span class="lang" (click)="lang = 'DE';updatedCustomButtonText();changeLanguage('DE')"
            [style.font-weight]="lang === 'DE' ? 'bold' : 'normal'">DE</span> |
          <span class="lang" (click)="lang = 'EN';updatedCustomButtonText();changeLanguage('EN')"
            [style.font-weight]="lang === 'EN' ? 'bold' : 'normal'">EN</span>
        </div>
        <div>
          <h5 *ngIf="lang === 'DE' " class="card-title text-center font-weight-bold">Herzlich Willkommen zum onSET!</h5>
          <h5 *ngIf="lang === 'EN' " class="card-title text-center font-weight-bold">Welcome to the onSET!</h5>
          <div *ngIf="bookingLoaded && participantsCounted" class="mt-2">
            <div class="card-title">
              <div *ngIf="displayStatus === 'SHOW_MOBILE_WARNING'">
                <div *ngIf="lang === 'DE' " class="text-center">Bitte rufen Sie diese Webseite zunächst mit Ihrem
                  Smartphone oder Tablet
                  auf.</div>
                <div *ngIf="lang === 'EN' " class="text-center">Please access this website first using your smartphone
                  or tablet.</div>
                <div class="d-flex justify-content-center mt-4">
                  <img style="height: 250px;margin: auto;" src="assets/qr-study-link.png">
                </div>
                <div class="d-flex justify-content-center mt-4">
                  <span>www.gast.de/onset-pc</span>
                </div>
              </div>
              <div *ngIf="displayStatus === 'SHOW_MOBILE'">
                <div *ngIf="desktopCtestDone">
                  <div *ngIf="lang === 'DE'">
                    Schön, dass Sie an der Erkundungsstudie zum onSET-mobil teilnehmen! Mittels Ihrer Teilnahme helfen
                    Sie
                    aktiv bei der Entwicklung eines neuen Sprachtests mit.<br><br>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">Sie legen den onSET am Computer oder Laptop ab. Im Anschluss
                        erhalten
                        Sie eine Einstufung Ihrer
                        Deutschkenntnisse basierend auf dem GER-Niveau.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen kurzen Fragebogen. Bitte notieren Sie sich
                        dafür Ihren Benutzernamen, den Sie bei der Registrierung auswählen.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">Sie legen den onSET am Smartphone oder Tablet ab.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen weiteren Fragebogen.</span>
                    </div>

                    Ihre Teilnahme lohnt sich: Wenn Sie alle vier Schritte vollständig abschließen, können Sie
                    attraktive
                    Preise von g.a.s.t. gewinnen - jeweils eine kostenlose Teilnahme am TestDaF, TestAS und einem
                    DUO-Kurs. <a href="https://www.gast.de/de/teilnahmebedingung-erkundungsstudie"
                      target="_blank">(Teilnahmebedingungen)</a><br><br>
                    Der Test dauert jeweils maximal 30 Minuten. Um ein valides Ergebnis zu erhalten, bearbeiten Sie ihn
                    bitte selbstständig und in einem ruhigen Raum.<br><br>
                    Sobald Sie sich registriert haben, können Sie mit der Erkundungsstudie beginnen.
                    Sie erhalten keine Bestätigungsemail. Bitte notieren Sie Ihren Benutzernamen.<br><br>
                    Bei Fragen melden Sie sich bei <a href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Herzlichen Dank und viel Freude beim Ausprobieren!<br><br>
                  </div>
                  <div *ngIf="lang === 'EN'">
                    Thank you for taking part in the onSET-mobile exploratory study! By taking part, you are providing
                    active support in the development of a new language test.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">You take the onSET on your computer or laptop. You will then
                        receive an assessment of your German
                        knowledge based on the CEFR level.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer a short questionnaire. Please note your user name that
                        you
                        select during registration.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">You take the onSET on your smartphone or tablet.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer another questionnaire.</span>
                    </div>
                    Your participation is worth it: If you complete these four steps to the end, you can win attractive
                    prizes from g.a.s.t. - free participation in the TestDaF, TestAS and a DUO course. <a
                      href="https://www.gast.de/de/conditions-of-participation-onset-mobile-exploratory-study"
                      target="_blank">(Conditions of participation)</a><br><br>
                    Each test lasts a maximum of 30 minutes. In order to get a valid result, please take the test
                    without external help and in a quiet room.<br><br>
                    As soon as you have registered, you can start the exploratory study.
                    You will not receive a confirmation email. Please make a note of your user name.<br><br>
                    If you have any questions, please contact <a
                      href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Thank you very much and have fun trying it out!<br><br>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="btn mt-4" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
                      (click)="startMobileOnset()">
                      <img src="assets/Laptop.png" style="font-size: smaller;cursor: pointer;" height="60px">
                      <span *ngIf="lang === 'DE' "> onSET starten</span>
                      <span *ngIf="lang === 'EN' "> Start onSET</span>
                    </button>
                    <button class="btn mt-4 ml-2" style="font-size: smaller;" [style.background-color]="'#dceced'"
                      [disabled]="!canGoToSurveyMobile" (click)="toLimeSurvey()">
                      <img src="assets/Notizblock.png" class="ml-2" style="font-size: smaller;cursor: pointer;"
                        height="60px">
                      <span *ngIf="lang === 'DE' "> Zum Fragebogen</span>
                      <span *ngIf="lang === 'EN' "> To the questionnaire</span>
                    </button>
                  </div>
                </div>
                <div *ngIf="!desktopCtestDone">
                  <div *ngIf="lang === 'DE' ">
                    Schön, dass Sie an der Erkundungsstudie zum onSET-mobil teilnehmen! Mittels Ihrer Teilnahme helfen
                    Sie
                    aktiv bei der Entwicklung eines neuen Sprachtests mit.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">Sie legen den onSET am Smartphone oder Tablet ab.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen kurzen Fragebogen. Bitte notieren Sie sich
                        dafür Ihren Benutzernamen, den Sie bei der Registrierung auswählen.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">Sie legen den onSET am Computer oder Laptop ab. Im Anschluss
                        erhalten
                        Sie eine Einstufung Ihrer
                        Deutschkenntnisse basierend auf dem GER-Niveau.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen weiteren Fragebogen.</span>
                    </div>

                    Ihre Teilnahme lohnt sich: Wenn Sie alle vier Schritte vollständig abschließen, können Sie
                    attraktive
                    Preise von g.a.s.t. gewinnen – jeweils eine kostenlose Teilnahme am TestDaF, TestAS und einem
                    DUO-Kurs. <a href="https://www.gast.de/de/teilnahmebedingung-erkundungsstudie"
                      target="_blank">(Teilnahmebedingungen)</a><br><br>
                    Der Test dauert jeweils maximal 30 Minuten. Um ein valides Ergebnis zu erhalten, bearbeiten Sie ihn
                    selbstständig und in einem ruhigen Raum.<br><br>
                    Sobald Sie sich registriert haben, können Sie mit der Erkundungsstudie beginnen.
                    Sie erhalten keine Bestätigungsemail. Bitte notieren Sie Ihren Benutzernamen.<br><br>
                    Bei Fragen melden Sie sich bei <a href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Herzlichen Dank und viel Freude beim Ausprobieren!<br><br>
                  </div>
                  <div *ngIf="lang === 'EN' ">
                    Thank you for taking part in the onSET-mobile exploratory study! By taking part, you are providing
                    active support in the development of a new language test.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">You take the onSET on your smartphone or tablet.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer a short questionnaire.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">You take the onSET on your computer or laptop. You will then
                        receive
                        an assessment of your German
                        knowledge based on the CEFR level.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer another questionnaire. Please note your user name that
                        you
                        select during registration.</span>
                    </div>
                    Your participation is worth it: If you complete these four steps to the end, you can win attractive
                    prizes from g.a.s.t. - free participation in the TestDaF, TestAS and a DUO course. <a
                      href="https://www.gast.de/de/conditions-of-participation-onset-mobile-exploratory-study"
                      target="_blank">(Conditions of participation)</a><br><br>
                    Each test lasts a maximum of 30 minutes. In order to get a valid result, please take the test
                    without
                    external help and in a quiet room.<br><br>
                    As soon as you have registered, you can start the exploratory study.
                    You will not receive a confirmation email. Please make a note of your user name.<br><br>
                    If you have any questions, please contact <a
                      href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Thank you very much and have fun trying it out!<br><br>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="btn mt-4" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
                      (click)="startMobileOnset()">
                      <img src="assets/smartphone.png" style="font-size: smaller;cursor: pointer;" height="60px">
                      <span *ngIf="lang === 'DE' "> onSET starten</span>
                      <span *ngIf="lang === 'EN' "> Start onSET</span>
                    </button>
                    <button class="btn mt-4 ml-2" style="font-size: smaller;" [style.background-color]="'#dceced'"
                      [disabled]="!canGoToSurveyMobile" (click)="toLimeSurvey()">
                      <img src="assets/Notizblock.png" class="ml-2" style="font-size: smaller;cursor: pointer;"
                        height="60px">
                      <span *ngIf="lang === 'DE' "> Zum Fragebogen</span>
                      <span *ngIf="lang === 'EN' "> To the questionnaire</span>
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="displayStatus === 'SHOW_DESKTOP_WARNING'">
                <div *ngIf="lang === 'DE' " class="text-center">Bitte rufen Sie diese Webseite zunächst mit Ihrem
                  Computer oder Laptop auf.
                </div>
                <div *ngIf="lang === 'EN' " class="text-center">Please access this website first using your computer or
                  laptop.
                </div>
                <div class="d-flex justify-content-center mt-4">
                  <a
                    href="https://www.gast.de/portal/onset-exam/onset-study-home">https://www.gast.de/portal/onset-exam/onset-study-home</a>
                </div>
              </div>
              <div *ngIf="displayStatus === 'SHOW_DESKTOP'">
                <div *ngIf="mobileCtestDone">
                  <div *ngIf="lang === 'DE' ">
                    Schön, dass Sie an der Erkundungsstudie zum onSET-mobil teilnehmen! Mittels Ihrer Teilnahme helfen
                    Sie
                    aktiv bei der Entwicklung eines neuen Sprachtests mit.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">Sie legen den onSET am Smartphone oder Tablet ab.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen kurzen Fragebogen. Bitte notieren Sie sich
                        dafür Ihren Benutzernamen, den Sie bei der Registrierung auswählen.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">Sie legen den onSET am Computer oder Laptop ab. Im Anschluss
                        erhalten
                        Sie eine Einstufung Ihrer
                        Deutschkenntnisse basierend auf dem GER-Niveau.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen weiteren Fragebogen.</span>
                    </div>

                    Ihre Teilnahme lohnt sich: Wenn Sie alle vier Schritte vollständig abschließen, können Sie
                    attraktive
                    Preise von g.a.s.t. gewinnen – jeweils eine kostenlose Teilnahme am TestDaF, TestAS und einem
                    DUO-Kurs. <a href="https://www.gast.de/de/teilnahmebedingung-erkundungsstudie"
                      target="_blank">(Teilnahmebedingungen)</a><br><br>
                    Der Test dauert jeweils maximal 30 Minuten. Um ein valides Ergebnis zu erhalten, bearbeiten Sie ihn
                    selbstständig und in einem ruhigen Raum.<br><br>
                    Sobald Sie sich registriert haben, können Sie mit der Erkundungsstudie beginnen.
                    Sie erhalten keine Bestätigungsemail. Bitte notieren Sie Ihren Benutzernamen.<br><br>
                    Bei Fragen melden Sie sich bei <a href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Herzlichen Dank und viel Freude beim Ausprobieren!<br><br>
                  </div>
                  <div *ngIf="lang === 'EN' ">
                    Thank you for taking part in the onSET-mobile exploratory study! By taking part, you are providing
                    active support in the development of a new language test.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">You take the onSET on your smartphone or tablet.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer a short questionnaire.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">You take the onSET on your computer or laptop. You will then
                        receive
                        an assessment of your German
                        knowledge based on the CEFR level.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer another questionnaire. Please note your user name that
                        you
                        select during registration.</span>
                    </div>

                    Your participation is worth it: If you complete these four steps to the end, you can win attractive
                    prizes from g.a.s.t. - free participation in the TestDaF, TestAS and a DUO course. <a
                      href="https://www.gast.de/de/conditions-of-participation-onset-mobile-exploratory-study"
                      target="_blank">(Conditions of participation)</a><br><br>
                    Each test lasts a maximum of 30 minutes. In order to get a valid result, please take the test
                    without
                    external help and in a quiet room.<br><br>
                    As soon as you have registered, you can start the exploratory study.
                    You will not receive a confirmation email. Please make a note of your user name.<br><br>
                    If you have any questions, please contact <a
                      href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Thank you very much and have fun trying it out!<br><br>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="btn mt-4" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
                      (click)="startDesktopOnset()">
                      <img src="assets/smartphone.png" style="font-size: smaller;cursor: pointer;" height="60px">
                      <span *ngIf="lang === 'DE' "> onSET starten</span>
                      <span *ngIf="lang === 'EN' "> Start onSET</span>
                    </button>
                    <button class="btn mt-4 ml-2" style="font-size: smaller;" [style.background-color]="'#dceced'"
                      [disabled]="!canGoToSurveyDesktop" (click)="toLimeSurvey()">
                      <img src="assets/Notizblock.png" class="ml-2" style="font-size: smaller;cursor: pointer;"
                        height="60px">
                      <span *ngIf="lang === 'DE' "> Zum Fragebogen</span>
                      <span *ngIf="lang === 'EN' "> To the questionnaire</span>
                    </button>
                  </div>
                </div>
                <div *ngIf="!mobileCtestDone">
                  <div *ngIf="lang === 'DE'">
                    Schön, dass Sie an der Erkundungsstudie zum onSET-mobil teilnehmen! Mittels Ihrer Teilnahme helfen
                    Sie
                    aktiv bei der Entwicklung eines neuen Sprachtests mit.<br><br>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">Sie legen den onSET am Computer oder Laptop ab. Im Anschluss
                        erhalten
                        Sie eine Einstufung Ihrer
                        Deutschkenntnisse basierend auf dem GER-Niveau.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen kurzen Fragebogen. Bitte notieren Sie sich
                        dafür Ihren Benutzernamen, den Sie bei der Registrierung auswählen.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">Sie legen den onSET am Smartphone oder Tablet ab.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">Sie beantworten einen weiteren Fragebogen.</span>
                    </div>

                    Ihre Teilnahme lohnt sich: Wenn Sie alle vier Schritte vollständig abschließen, können Sie
                    attraktive
                    Preise von g.a.s.t. gewinnen - jeweils eine kostenlose Teilnahme am TestDaF, TestAS und einem
                    DUO-Kurs. <a href="https://www.gast.de/de/teilnahmebedingung-erkundungsstudie"
                      target="_blank">(Teilnahmebedingungen)</a><br><br>
                    Der Test dauert jeweils maximal 30 Minuten. Um ein valides Ergebnis zu erhalten, bearbeiten Sie ihn
                    bitte selbstständig und in einem ruhigen Raum.<br><br>
                    Sobald Sie sich registriert haben, können Sie mit der Erkundungsstudie beginnen.
                    Sie erhalten keine Bestätigungsemail. Bitte notieren Sie Ihren Benutzernamen.<br><br>
                    Bei Fragen melden Sie sich bei <a href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Herzlichen Dank und viel Freude beim Ausprobieren!<br><br>
                  </div>
                  <div *ngIf="lang === 'EN'">
                    Thank you for taking part in the onSET-mobile exploratory study! By taking part, you are providing
                    active support in the development of a new language test.<br><br>

                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Laptop.png">
                      <span class="instruction-text">You take the onSET on your computer or laptop. You will then
                        receive an assessment of your German
                        knowledge based on the CEFR level.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer a short questionnaire. Please note your user name that
                        you
                        select during registration.</span>
                    </div>
                    <div class="mt-2 instruction-container">
                      <img class="instruction-icon" src="assets/smartphone.png">
                      <span class="instruction-text">You take the onSET on your smartphone or tablet.</span>
                    </div>
                    <div class="mt-2 instruction-container mb-4">
                      <img class="instruction-icon" src="assets/Notizblock.png">
                      <span class="instruction-text">You answer another questionnaire.</span>
                    </div>
                    Your participation is worth it: If you complete these four steps to the end, you can win attractive
                    prizes from g.a.s.t. - free participation in the TestDaF, TestAS and a DUO course. <a
                      href="https://www.gast.de/de/conditions-of-participation-onset-mobile-exploratory-study"
                      target="_blank">(Conditions of participation)</a><br><br>
                    Each test lasts a maximum of 30 minutes. In order to get a valid result, please take the test
                    without external help and in a quiet room.<br><br>
                    As soon as you have registered, you can start the exploratory study.
                    You will not receive a confirmation email. Please make a note of your user name.<br><br>
                    If you have any questions, please contact <a
                      href="mailto:kontakt@gast.de">kontakt@gast.de</a><br><br>
                    Thank you very much and have fun trying it out!<br><br>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="btn mt-4" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
                      (click)="startDesktopOnset()">
                      <img src="assets/Laptop.png" style="font-size: smaller;cursor: pointer;" height="60px">
                      <span *ngIf="lang === 'DE' "> onSET starten</span>
                      <span *ngIf="lang === 'EN' "> Start onSET</span>
                    </button>
                    <button class="btn mt-4 ml-2" style="font-size: smaller;" [style.background-color]="'#dceced'"
                      [disabled]="!canGoToSurveyDesktop" (click)="toLimeSurvey()">
                      <img src="assets/Notizblock.png" class="ml-2" style="font-size: smaller;cursor: pointer;"
                        height="60px">
                      <span *ngIf="lang === 'DE' "> Zum Fragebogen</span>
                      <span *ngIf="lang === 'EN' "> To the questionnaire</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!bookingLoaded || !participantsCounted" class="mt-2">
              <span *ngIf="lang === 'DE' ">Daten werden geladen ...</span>
              <span *ngIf="lang === 'EN' ">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="onsetStarted" class="container-fluid" [ngClass]="{'p-0': mobileMode, 'h-100': mobileMode}">
  <gast-onset-cloze-test style="height: 100%;" [mobileMode]="mobileMode" [clozeTestModel]="clozeTestModel"
    [clozeTestStyleModel]="clozeTestStyleModel" [showResult]="true" [showEndTestButton]="false" [showGer]="false"
    (startTest)=onStartTest($event) (bookingInitialized)=onBookingInit($event) (testSaved)=onTestHasBeenSaved($event)
    (clozeTest)=onClozeTestCompleted() (testResult)=onTestResult($event) [showCustomButton]="showCustomButton"
    [customButtonIcon]="customButtonIcon" [customButtonIconHeight]="customButtonIconHeight"
    [customResultLevelText]="customResultLevelText" [showIntroduction]="showIntroduction"
    [customButtonText]="customButtonText" (customButton)="toLimeSurvey()" [gerInfoNewTab]="true"
    (gerInfoClick)="onGerInfoClicked()">
  </gast-onset-cloze-test>
</div>